export const DEFAULT_LANG: string = (import.meta.env.VITE_INIT_LANG as string | undefined) ?? 'en';
export const SUBDOMAIN: string = (import.meta.env.VITE_SUBDOMAIN as string | undefined) ?? '';
export const GOOGLE_TAG_ID: string = SUBDOMAIN === 'vn' ? 'G-TV86R0RB6V' : 'GTM-N9WG7PT4';
